module.exports = __webpack_public_path__ + "img/SKMA_rules7.3c681ed1.png";